(function storageTypeDefinition() {
    'use strict';
    angular.module('Entities')
        .service('storageTypeService', [
            'restUrlBuilder', function storageTypeDefinition(restUrlBuilder) {

                restUrlBuilder = restUrlBuilder('auth');

                this.get = function (id, name) {

                    var params = { Id:id, Name:name };

                    return restUrlBuilder.all('StorageTypes').get({ params: params });
                };
            }
        ]);
})();